<template>
    <v-layout row wrap>
        <!--        <v-flex xs12 v-on:keyup="submitSearch">-->
        <!--            <v-text-field ref="searchInput"-->
        <!--                          v-model="searchText"-->
        <!--                          :append-icon="'fas fa-search'"-->
        <!--                          clear-icon="fas fa-times"-->
        <!--                          clearable box-->
        <!--                          placeholder="Pesquisa"-->
        <!--                          type="text"-->
        <!--                          @click:append="applySearch"-->
        <!--                          @click:clear="clearSearch"-->
        <!--            ></v-text-field>-->
        <!--        </v-flex>-->
        <v-flex xs12>
            <div class="text-xs-left">
                <v-btn flat
                       @click="goBack">
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ $vuetify.t('$vuetify.back') }}
                </v-btn>
            </div>
        </v-flex>
        <v-flex xs12 sm6 md4 xl3
                v-for="item in items"
                :key="item.id"
        >
            <!--The card representing the Item's Group can be defined with 4 elements:
            1 - image   2 - title   3 - price   4 - price per unit
            It is mandatory to have an image to be displayed -->
            <v-card class="catalog-item-card">
                <v-img v-if="item.images && baseUrl" v-bind:src="baseUrl + item.images[0]"
                       aspect-ratio="1.48"
                       @click="goToDetail(item.id, item.group_id)"></v-img>
                <v-img v-if="!item.images" :src="require('@/assets/no-photo.jpg')"
                       aspect-ratio="1.48"
                       @click="goToDetail(item.id, item.group_id)"></v-img>

                <v-card-title primary-title @click="goToDetail(item.id, item.group_id)">
                    <div>
                        <div class="headline primary--text">{{ item.name }}</div>
                        <span v-if="item.price"
                              class="catalog-item-price">{{ item.price }}&nbsp;{{ currencySymbol }}</span><br>
                        <span v-if="item.price_per_unit" class="catalog-item-unitprice grey--text">{{
                                item.price_per_unit
                            }}&nbsp;{{ currencySymbol }} {{ item.price_per_unit_type }}</span>
                    </div>
                </v-card-title>

                <v-card-actions>
                    <v-layout align-center justify-center>
                        <v-btn color="primary" flat="flat" @click="goToDetail(item.id, item.group_id)">
                            <v-icon left small>fal fa-search</v-icon>
                            {{ $vuetify.t('$vuetify.shop.item_details_view') }}
                        </v-btn>

                        <v-btn color="primary" flat="flat" v-if="item.price && item.stock > 0 && !item.menu"
                               @click="addToCart(item.id)">
                            <v-icon left small>fal fa-shopping-cart</v-icon>
                            {{ $vuetify.t('$vuetify.add') }}
                        </v-btn>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-flex>
        <mugen-scroll :handler="getNextItems" :should-handle="!loading && hasMoreResults">
            <!-- Verifying the flag which defines whether or not there are more results to load -->
            <p v-if="loading">...</p>
        </mugen-scroll>
    </v-layout>
</template>

<script>

import {itemsService} from '@/_services/shop/items.service';
import { getErrorMessage, getUrlParams} from '@/_helpers';
import MugenScroll from 'vue-mugen-scroll';
import {mapGetters} from "vuex";

export default {
    name: "SearchResults",
    components: {MugenScroll},
    data() {
        return {
            items: [],
            searchText: null,
            loading: false,
            hasMoreResults: true,
            nextPageUrl: null
        }
    },
    computed: {
        ...mapGetters({
            currencySymbol: 'configs/currencySymbol',
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    methods: {
        getSearchResults() {
            this.$store.dispatch("loader/setLoading", true);
            if (this.searchText) {
                itemsService.search(this.searchText).then(result => {
                        this.nextPageUrl = result.next;
                        this.hasMoreResults = this.nextPageUrl !== undefined;
                        this.items = result.results;
                        this.$store.dispatch("loader/setLoading", false);
                    },
                    error => {
                        getErrorMessage(error, 'Getting Search Results', this);
                    }
                );
            } else {
                this.items = []
            }
        },
        submitSearch: function (e) {
            if (e.keyCode === 13) {
                this.applySearch();
            }
        },
        // applySearch() {
        //     this.getSearchResults();
        // },
        // clearSearch() {
        // },
        getNextItems() {
            //Setting the loading flag to true
            this.loading = true;
            if (this.nextPageUrl !== null) {
                this.$store.dispatch("loader/setLoading", true);
                itemsService.getAll(getUrlParams(this.nextPageUrl)).then(result => {
                        this.items = this.items.concat(result.results);
                        this.loading = false;
                        this.nextPageUrl = result.next;
                        this.hasMoreResults = this.nextPageUrl !== undefined;
                        this.$store.dispatch("loader/setLoading", false);
                    },
                    error => {
                        getErrorMessage(error, 'Getting the Items', this);
                    }
                );
            } else
                this.loading = false
        }, /**
         * This function is triggered when the user selects an Item to access its detail;
         * this works as a redirect to the Items's detail interface.
         * @param pk
         **/
        goToDetail: function (pk) {
            this.$router.push({
                name: 'shop-item-detail', params: {
                    id: pk
                }
            })
        },
        /**
         * Adding a new Item to the Shopping Cart, which is stored on the local storage
         * @param pk
         */
        addToCart: function (pk) {
            this.$store.dispatch("shop/addToCart", pk);
        },
        /**
         *
         */
        goBack() {
            this.$router.push({name: 'catalog'})
        },
    },
    watch: {
        /**
         * https://router.vuejs.org/guide/essentials/dynamic-matching.html#reacting-to-params-changes
         * To react to params changes in the same component, it is necessary to watch the $route object
         * @param to
         * @param from
         */
        $route(to, from) {
            var toSearch = to.query.search;
            var fromSearch = from.query.search;
            if (toSearch !== fromSearch) {
                this.searchText = toSearch;
                this.getSearchResults()
            }
        }
    },
    mounted() {
        this.searchText = this.$route.query.search;
        this.getSearchResults()
    }

}
</script>

<style scoped>

</style>